<template>
    <section id="wrapper-create-meetup">
        <cm-back
            sectionTitle="Manage"
            :contentName="meetup ? meetup.name : 'Create meetup'"
            :to="{name: 'manage', query: {view: 'meetups'}}"
        ></cm-back>

        <div class="container mt-3">
            <div class="row d-flex justify-content-center flex-column align-items-center">
                <div
                    class="w-100 p-5 d-flex justify-content-center align-items-center"
                    v-if="loadingMeetup"
                >
                    <b-spinner></b-spinner>
                </div>
                <div v-show="!loadingMeetup" class="create-edit-meetups px-3">
                    <div class="form-block">
                        <h3 class="d-none d-lg-block">Name and Location</h3>
                        <div class="fields-container first-step">
                            
                            <md-field class="name" :class="getValidationClass('name')">
                                <label for="meetup-title">Meetup title</label>
                                <md-input
                                    id="meetup-title"
                                    name="meetup-title"
                                    v-model="firstStep.name"
                                    :maxlength="100"
                                ></md-input>
                                <span
                                    class="md-error"
                                    v-if="!$v.firstStep.name.required"
                                >Name is required</span>
                                <span
                                    class="md-error"
                                    v-else-if="!$v.firstStep.name.minLength"
                                >Invalid name</span>
                            </md-field>
                            <div class="w-100 d-flex flex-column flex-md-row">
                                <div class="md-layout-item pr-md-3">
                                    <md-checkbox class="pt-3 pt-md-0" v-model="online">Online Meetup</md-checkbox>
                                    <md-field :class="getValidationClass('venue')" v-if="!online">
                                        <label for="venue">Venue name</label>
                                        <md-input v-model="firstStep.venue" name="venue" id="venue"></md-input>

                                        <md-menu
                                            md-size="auto"
                                            md-direction="bottom-end"
                                            :md-active.sync="venueList"
                                            :mdCloseOnSelect="true"
                                        >
                                            <md-button class="md-icon-button" md-menu-trigger>
                                                <md-icon>history</md-icon>
                                            </md-button>
                                            <md-menu-content>
                                                <md-menu-item
                                                    v-for="venue in venues"
                                                    :key="venue.location_google_id"
                                                    class="venues-list-item"
                                                    @click="selectVenue(venue)"
                                                >
                                                    <div class="venues-list-item-content">
                                                        <strong>{{venue.location_name}}</strong>
                                                        <small>{{venue.location_address}}</small>
                                                    </div>
                                                </md-menu-item>
                                            </md-menu-content>
                                        </md-menu>

                                        <span
                                            class="md-error"
                                            v-if="!$v.firstStep.venue.required"
                                        >Venue is required</span>
                                        <span
                                            class="md-error"
                                            v-else-if="!$v.firstStep.venue.minLength"
                                        >Invalid venue</span>
                                    </md-field>
                                </div>
                                <div class="md-layout-item">
                                    <span class="seats-box">
                                        <md-field
                                            class="seats"
                                            :class="getValidationClass('seats')"
                                        >
                                            <label for="meetup-title">Total seats</label>
                                            <md-input
                                                id="meetup-seats"
                                                name="meetup-seats"
                                                type="number"
                                                v-model="firstStep.seats"
                                            ></md-input>
                                            <span
                                                class="md-error"
                                                v-if="!$v.firstStep.seats.minValue || !$v.firstStep.seats.required"
                                            >Total seats is required</span>
                                        </md-field>
                                    </span>
                                    <md-field :class="getValidationClass('lat')" v-show="!online">
                                        <input
                                            class="md-input googlemaps"
                                            autocomplete="disabled"
                                            ref="maps_autocomplete"
                                            type="search"
                                            :disabled="online"
                                            :value="firstStep.address"
                                            placeholder="Type address with street number..."
                                        />
                                        <span
                                            class="md-error"
                                            v-if="true || !$v.firstStep.lat.required"
                                        >Address is required</span>
                                    </md-field>
                                </div>
                            </div>
                              <!-- external platform URL-->
                              <md-field
                            class="meetup-url mb-3"
                            
                            :class="getValidationClass('external_platform_url')"
                        >
                            <label for="meetup-external-platform-url">External Platform URL</label>
                            <md-input
                                id="meetup-external-platform-url"
                                name="meetup-external-platform-url"
                                v-model="firstStep.external_platform_url"
                            ></md-input>
                            <span
                                class="md-helper-text"
                            >Fill this field with a valid URL (http(s)"//domain.com")</span>
                            <span
                                class="md-error"
                                v-if="!$v.firstStep.external_platform_url.url"
                            >Invalid URL (try adding "http(s)://")</span>
                        </md-field>
                            <!-- end external platform URL-->


                            <md-field
                                class="meetup-url"
                                v-if="online"
                                :class="getValidationClass('url')"
                            >
                                <label for="meetup-url">Meetup URL</label>
                                <md-input
                                    id="meetup-url"
                                    name="meetup-url"
                                    placeholder="Provide a URL to the event"
                                    v-model="firstStep.url"
                                ></md-input>
                                <span
                                    class="md-error"
                                    v-if="!$v.firstStep.url.required"
                                >URL is required</span>
                                <span
                                    class="md-error"
                                    v-else-if="!$v.firstStep.url.url"
                                >Invalid URL (try adding "http://")</span>
                            </md-field>
                            <md-field
                                class="meetup-url mb-3"
                                v-if="online"
                                :class="getValidationClass('videoUrl')"
                            >
                                <label for="meetup-video-url">Video recording URL</label>
                                <md-input
                                    id="meetup-video-url"
                                    name="meetup-video-url"
                                    v-model="firstStep.videoUrl"
                                ></md-input>
                                <span
                                    class="md-helper-text"
                                >Fill this field with the URL to the video recording <strong>(Vimeo or Youtube)</strong></span>
                                <span
                                    class="md-error"
                                    v-if="!$v.firstStep.videoUrl.url"
                                >Invalid URL (try adding "http://")</span>
                            </md-field>
                            
                            <p
                                class="show-map"
                                v-show="!online"
                                @click="showMap = !showMap"
                            >{{showMap ? "Hide" : "Show"}} Map</p>
                            <iframe
                                :class="showMap ? 'show-map' : ''"
                                v-show="!online"
                                frameborder="0"
                                style="border:0"
                                :src="`https://www.google.com/maps/embed/v1/place?q=place_id:${firstStep.mapsId}&key=AIzaSyBLlVbhwJ4f3Clbk2Lg7AaZsX-pf_JlABU`"
                            ></iframe>
                        </div>
                    </div>

                    <div class="form-block">
                        <h3 class="d-none d-lg-block">
                            Date, time
                            <br />and Call for Speakers
                        </h3>
                        <div class="fields-container second-step">
                            <div class="d-flex flex-column mb-3">
                                <div class="d-flex flex-wrap time-container">
                                    <div class="w-100 mb-4">
                                        <md-autocomplete
                                            :md-fuzzy-search="false"
                                            :class="{'md-invalid': $v.timezone.$invalid && $v.timezone.$dirty}"
                                            v-model="timezone"
                                            :md-options="timezones"
                                        >
                                            <label>Timezone</label>
                                            <span
                                                class="md-helper-text"
                                            >Valid both for Meetup and Call for Speakers</span>
                                            <span
                                                class="md-error"
                                                v-if="!$v.timezone.required"
                                            >Timezone is required</span>
                                        </md-autocomplete>
                                    </div>
                                    <div class="date pr-sm-2">
                                        <md-datepicker
                                            class="mr-0"
                                            :md-disabled-dates="date => checkDate(date, 'first')"
                                            v-model="secondStep.startDate"
                                        >
                                            <label>Start date</label>
                                        </md-datepicker>
                                        <span
                                            class="md-error"
                                            v-if="~dateErrorFlag.indexOf('date_time_not_valid')"
                                        >Start date is required</span>
                                        <span
                                            class="md-error"
                                            v-else-if="~dateErrorFlag.indexOf('date_mismatch')"
                                        >Start date must be set before end date</span>
                                    </div>

                                    <div class="time pl-sm-2">
                                        <Timepicker
                                            v-model="secondStep.startTime"
                                            label="Start time"
                                        ></Timepicker>
                                        <span
                                            class="md-error"
                                            v-if="~dateErrorFlag.indexOf('date_time_not_valid')"
                                        >Start time is required</span>
                                        <span
                                            class="md-error"
                                            v-else-if="~dateErrorFlag.indexOf('time_mismatch')"
                                        >Start time must be set before end time</span>
                                    </div>
                                </div>
                                <div
                                    class="d-flex flex-wrap time-container"
                                    v-if="secondStep.startTime"
                                >
                                    <div class="date pr-sm-2">
                                        <md-datepicker
                                            :md-disabled-dates="date => checkDate(date, 'second')"
                                            v-model="secondStep.endDate"
                                        >
                                            <label>End date</label>
                                        </md-datepicker>
                                        <span
                                            class="md-error"
                                            v-if="~dateErrorFlag.indexOf('date_time_not_valid')"
                                        >End date is required</span>
                                        <span
                                            class="md-error"
                                            v-else-if="~dateErrorFlag.indexOf('date_mismatch')"
                                        >End date must be set after start date</span>
                                    </div>
                                    <div class="time pl-sm-2">
                                        <Timepicker v-model="secondStep.endTime" label="End time"></Timepicker>
                                        <span
                                            class="md-error"
                                            v-if="~dateErrorFlag.indexOf('date_time_not_valid')"
                                        >End time is required</span>
                                        <span
                                            class="md-error"
                                            v-else-if="~dateErrorFlag.indexOf('time_mismatch')"
                                        >End time must be set after start time</span>
                                    </div>
                                </div>
                                <div class="cfp-check" v-if="!isEdit || !callForPaperSlug">
                                    <span id="cfp-tooltip-box">
                                        <md-checkbox
                                            v-model="secondStep.callForPaper"
                                            id="cfp-check"
                                            :disabled="!dateSet"
                                        ></md-checkbox>
                                        <label for="cfp-check">Open call for speakers</label>
                                    </span>
                                    <b-tooltip
                                        target="cfp-tooltip-box"
                                        v-if="!dateSet"
                                        triggers="hover"
                                    >Call for Speaker can be set up after adding meetup dates.</b-tooltip>
                                </div>
                                <b-collapse class="mt-2" id="cfp" v-model="secondStep.callForPaper">
                                    <div class="cfp-box">
                                        <span v-if="isEdit && callForPaperSlug">
                                            CFS public URL:
                                            <a
                                                class="ml-2"
                                                :href="'//events.codemotion.com/call-for-speakers/' + callForPaperSlug"
                                                target="_blank"
                                            >/call-for-speakers/{{callForPaperSlug}}</a>
                                        </span>
                                        <span v-else>
                                            <strong>Call for Speakers:</strong>
                                        </span>
                                        <warning
                                            v-if="!meetup || (meetup && !meetup.cfp_slug)"
                                            class="mb-2"
                                        >WARNING! Once uploaded, Call for Speakers cannot be closed!</warning>
                                        <p class="mb-1">
                                            <em>Select open and close dates, write a description and choose time slots speakers must stick with.</em>
                                        </p>
                                        <span v-if="!dateSet" class="text-danger">
                                            <em>You must fill meetup's start and end dates before setting CFS's ones.</em>
                                        </span>

                                        <div class="d-flex flex-wrap time-container">
                                            <div class="date pr-sm-2">
                                                <md-datepicker
                                                    class="mr-0"
                                                    :md-disabled-dates="date => checkDate(date, 'first', true)"
                                                    v-model="secondStep.cfpOpenDate"
                                                >
                                                    <label>CFS open date</label>
                                                </md-datepicker>
                                                <span
                                                    class="md-error"
                                                    v-if="~dateErrorFlag.indexOf('cfp_date_time_not_valid')"
                                                >Open date is required</span>
                                                <span
                                                    class="md-error"
                                                    v-else-if="~dateErrorFlag.indexOf('cfp_date_mismatch')"
                                                >Open date must be set before close date</span>
                                            </div>

                                            <div class="time pl-sm-2">
                                                <Timepicker
                                                    v-model="secondStep.cfpOpenTime"
                                                    label="CFS open time"
                                                    :disabled="!secondStep.endDate"
                                                ></Timepicker>
                                                <span
                                                    class="md-error"
                                                    v-if="~dateErrorFlag.indexOf('cfp_date_time_not_valid')"
                                                >Open time is required</span>
                                                <span
                                                    class="md-error"
                                                    v-else-if="~dateErrorFlag.indexOf('cfp_time_mismatch')"
                                                >Open time must be set before close time</span>
                                            </div>
                                        </div>
                                        <div
                                            class="d-flex flex-wrap time-container"
                                            v-if="secondStep.cfpOpenTime"
                                        >
                                            <div class="date pr-sm-2">
                                                <md-datepicker
                                                    :md-disabled-dates="date => checkDate(date, 'second', true)"
                                                    v-model="secondStep.cfpCloseDate"
                                                >
                                                    <label>CFS close date</label>
                                                </md-datepicker>
                                                <span
                                                    class="md-error"
                                                    v-if="~dateErrorFlag.indexOf('cfp_date_time_not_valid')"
                                                >Close date is required</span>
                                                <span
                                                    class="md-error"
                                                    v-else-if="~dateErrorFlag.indexOf('cfp_date_mismatch')"
                                                >Close date must be set after open date</span>
                                            </div>
                                            <div class="time pl-sm-2">
                                                <Timepicker
                                                    v-model="secondStep.cfpCloseTime"
                                                    label="CFS close time"
                                                ></Timepicker>
                                                <span
                                                    class="md-error"
                                                    v-if="~dateErrorFlag.indexOf('cfp_date_time_not_valid')"
                                                >Close time is required</span>
                                                <span
                                                    class="md-error"
                                                    v-else-if="~dateErrorFlag.indexOf('cfp_time_mismatch')"
                                                >Close time must be set after open time</span>
                                            </div>
                                        </div>
                                        <description
                                            class="d-none d-sm-block"
                                            v-model="secondStep.cfpDescription"
                                            :editorOnly="true"
                                        ></description>
                                        <md-field class="d-sm-none mt-4 mb-5 border-0">
                                            <label>Description</label>
                                            <md-textarea
                                                placeholder="Describe what kind of submissions you need..."
                                                v-model="secondStep.cfpDescription"
                                            ></md-textarea>
                                            <span class="md-helper-text pb-3">
                                                <a
                                                    href="https://commonmark.org/help/"
                                                    class="d-flex align-items-center"
                                                    target="_blank"
                                                >
                                                    Markdown styleguide
                                                    <i
                                                        class="material-icons"
                                                    >open_in_new</i>
                                                </a>
                                                *Bigger device recommended
                                            </span>
                                            <span
                                                class="md-error"
                                                v-if="!$v.secondStep.cfpDescription.required"
                                            >CFS description is required</span>
                                        </md-field>
                                        <div class="mt-sm-3 pt-3 pt-sm-0 mb-3">
                                            Available talk's lengths (in minutes):
                                            <md-field
                                                :class="getValidationClass('cfpTimeSlots', 'secondStep')"
                                            >
                                                <label for="time-slots">Add length and press enter</label>
                                                <md-input
                                                    v-model="timeSlotsInput"
                                                    type="number"
                                                    id="time-slots"
                                                    name="time-slots"
                                                    autocomplete="cfp_time_slots"
                                                    @keyup.enter.native="timeSlotsInput && timeSlotsInput >= 1 && !~secondStep.cfpTimeSlots.indexOf(timeSlotsInput) && secondStep.cfpTimeSlots.push(timeSlotsInput); timeSlotsInput = ''"
                                                ></md-input>
                                                <span
                                                    class="add-label"
                                                    @click="timeSlotsInput && timeSlotsInput >= 1 && !~secondStep.cfpTimeSlots.indexOf(timeSlotsInput) && secondStep.cfpTimeSlots.push(timeSlotsInput); timeSlotsInput = ''"
                                                >Add</span>
                                                <span
                                                    class="md-error"
                                                    v-if="!$v.secondStep.cfpTimeSlots.required"
                                                >At least one length must be specified</span>
                                            </md-field>
                                            <md-chip
                                                md-deletable
                                                v-for="(slot, index) in secondStep.cfpTimeSlots"
                                                :key="index"
                                                class="mr-2 mt-2"
                                                @md-delete="secondStep.cfpTimeSlots.splice(index, 1)"
                                            >{{slot}} minutes</md-chip>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                    <div class="form-block">
                        <h3 class="d-none d-lg-block">Language</h3>
                        <div class="fields-container d-fex flex-row">
                            <md-field>
                                <label for="lang">Select an optional language</label>
                                <md-select name="lang" v-model="firstStep.language">
                                    <md-option
                                        v-for="(lang, code) in languages"
                                        v-bind:key="code"
                                        :value="code"
                                    >{{lang}}</md-option>
                                </md-select>
                            </md-field>
                            <div class="delete-button">
                                <button
                                    type="button"
                                    class="md-button md-icon-button md-dense md-input-action md-clear md-theme-default"
                                    tabindex="-1"
                                    @click="deleteLang()"
                                >
                                    <div class="md-ripple">
                                        <div class="md-button-content">
                                            <i
                                                class="md-icon md-icon-font md-icon-image md-theme-default"
                                            >
                                                <svg
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    width="24"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                                                    />
                                                    <path d="M0 0h24v24H0z" fill="none" />
                                                </svg>
                                            </i>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-block">
                        <h3 class="d-none d-lg-block">
                            Description
                            <br />and Banner
                        </h3>
                        <div class="fields-container third-step">
                            <description
                                class="d-none d-sm-block"
                                v-model="thirdStep.description"
                                :editorOnly="true"
                            ></description>
                            <md-field class="d-sm-none mb-5 border-0">
                                <label>Description</label>
                                <md-textarea v-model="thirdStep.description"></md-textarea>
                                <span class="md-helper-text">
                                    <a
                                        href="https://commonmark.org/help/"
                                        class="d-flex align-items-center"
                                        target="_blank"
                                    >
                                        Markdown styleguide
                                        <i class="material-icons">open_in_new</i>
                                    </a>
                                    *Bigger device recommended
                                </span>
                            </md-field>
                            <div class="add-meetup-banner flex-wrap mb-3">
                                <div class="banner flex-wrap">
                                    <div v-if="!showInstructions" class="wrap-info-croppa">
                                        <h5>Add a cover image</h5>
                                        <p>Max file size: 1MB. Recommended dimensions: 800x512 px</p>
                                    </div>
                                    <label
                                        v-if="thirdStep.bannerPreview && !editBanner"
                                        for="meetup-banner-upload"
                                        style="background-image:url('/img/checkboard.png')"
                                    >
                                        <i
                                            class="material-icons edit"
                                            @click="editBanner = true"
                                        >delete</i>
                                        <img :src="thirdStep.bannerPreview" alt="banner" />
                                    </label>
                                    <div
                                        v-else-if="!thirdStep.bannerPreview || editBanner"
                                        class="d-flex justify-content-center"
                                    >
                                        <croppa
                                            placeholder
                                            :width="400"
                                            :height="256"
                                            :show-remove-button="true"
                                            :zoom-speed="5"
                                            removeButtonColor="#ff5c00"
                                            accept=".jpeg, .png, .jpg"
                                            :file-size-limit="1000000"
                                            ref="croppa"
                                            @new-image-drawn="showInstructions = true; dirty = true"
                                            @image-remove="showInstructions = false; editBanner = false;colors='';showColorPicker = false"
                                            @file-size-exceed="alert('File size exceeds. Max size: 1MB')"
                                            @file-type-mismatch="alert('The file type chosen is not valid')"
                                            initial-size="contain"
                                            initial-position="center"
                                            :canvas-color="canvasColor"
                                        ></croppa>
                                        <div v-if="showInstructions" class="wrap-checkboard">
                                            <div
                                                class="img"
                                                style="background-image:url('/img/checkboard.png')"
                                            ></div>
                                        </div>
                                        <div v-if="showInstructions" class="instructions">
                                            Drag to move
                                            <br />and scroll or pinch to zoom
                                        </div>
                                    </div>
                                </div>
                                <a
                                    v-if="showInstructions && !showColorPicker"
                                    href="#"
                                    @click.prevent="showColorPicker= !showColorPicker"
                                >Change background color</a>
                                <div v-if="showColorPicker" class="wrap-color-picker">
                                    <div
                                        @click.prevent="showColorPicker=false"
                                        class="wrap-close-button"
                                    >
                                        <i class="material-icons">close</i>
                                    </div>
                                    <chrome-picker v-model="colors" />
                                </div>
                            </div>

                            <!--  v-if="!firstStep.waitingList" -->
                            <div class="notify-box">
                                <md-checkbox
                                    v-model="thirdStep.reservationsVisibility"
                                    id="res-vis"
                                ></md-checkbox>
                                <label
                                    for="res-vis"
                                >Show the number of total seats and number of booked users on the meetup's public detail page.</label>
                            </div>
                            <div class="notify-box">
                                <md-checkbox v-model="thirdStep.autoWaiting" id="auto-waiting"></md-checkbox>
                                <label
                                    for="auto-waiting"
                                >If there are users in waiting list, automatically add them to the attendees' list when a spot gets free.</label>
                            </div>
                            <div v-if="isEdit && currentStatus !== 'draft'" class="notify-box mt-5">
                                <md-checkbox v-model="thirdStep.needEmail" id="need-email"></md-checkbox>
                                <label
                                    for="need-email"
                                >Send an e-mail about this update to all the people who have booked.</label>
                            </div>
                        </div>
                    </div>

                    <md-dialog-alert
                        :md-fullscreen="false"
                        class="alert-modal"
                        :md-active.sync="showUpdateResult"
                        md-title="Result"
                        :md-content="updateResultMessage"
                        @md-closed="newId && $router.replace({name: 'meetup-edit', params: {id: $route.params.id, meetupid: newId}})"
                    />

                    <md-dialog-confirm
                        :md-active.sync="deleteConfirm"
                        :md-fullscreen="false"
                        md-title="Are you sure?"
                        :md-content="currentStatus === 'draft' ? 'This meetup has not been published yet.<br> Are you sure you want to delete it?' : (reservations ? reservations + ' people has already reserved a seat for this meetup. If you delete this, they will be aknowledged by e-mail. Are you sure?' : 'This meetup is already published. Are you sure you want to delete it?')"
                        md-confirm-text="Yes. Delete it."
                        md-cancel-text="No, I changed my mind."
                        @md-cancel="deleteConfirm = false"
                        @md-confirm="deleteMeetup"
                    />
                    <md-dialog-confirm
                        :md-active.sync="publishConfirm"
                        :md-fullscreen="false"
                        md-title="Are you sure?"
                        md-content="You are publishing this meetup."
                        md-confirm-text="Yes. Publish it."
                        md-cancel-text="No, I changed my mind."
                        @md-cancel="publishConirm = false"
                        @md-confirm="draft = false; setDone(1)"
                    />
                </div>
            </div>
        </div>
        <div v-show="!loadingMeetup" class="actions-container" :class="{sticky: isEdit}">
            <div class="d-flex flex-column flex-sm-row px-sm-3">
                <button
                    v-if="isEdit && currentStatus !== 'draft'"
                    class="btn btn-outline-success justify-content-center d-flex align-items-center mb-sm-0 mb-3"
                    @click="draft = true; errorsCheck() && setDone(2)"
                    :disabled="loading"
                >
                    <b-spinner
                        small
                        label="Loading..."
                        class="mr-2"
                        variant="primary"
                        v-if="showSpinner[2]"
                    ></b-spinner>BACK TO DRAFT
                </button>
                <button
                    v-if="!isEdit"
                    :disabled="!dirty || loading"
                    class="btn btn-outline-success ml-sm-3 d-flex justify-content-center align-items-center"
                    @click="draft = true; errorsCheck() && setDone(0)"
                >
                    <b-spinner
                        small
                        label="Loading..."
                        class="mr-2"
                        variant="primary"
                        v-if="showSpinner[0]"
                    ></b-spinner>SAVE AS DRAFT
                </button>
                <button
                    v-else
                    :disabled="!dirty || loading"
                    class="btn ml-sm-3 d-flex justify-content-center align-items-center"
                    :class="{'btn-primary': isEdit && currentStatus === 'published', 'btn-outline-success': currentStatus === 'draft'}"
                    @click="draft = (currentStatus === 'published' ? false : true); errorsCheck() && setDone(0)"
                >
                    <b-spinner
                        small
                        label="Loading..."
                        class="mr-2"
                        :variant="currentStatus === 'published' ? 'light' : 'primary'"
                        v-if="showSpinner[0]"
                    ></b-spinner>UPDATE
                </button>
                <button
                    class="btn ml-sm-3 btn-primary justify-content-center d-flex align-items-center mt-sm-0 mt-3"
                    v-if="currentStatus !== 'published'"
                    @click="publishConfirm = errorsCheck()"
                    :disabled="loading"
                >
                    <b-spinner
                        small
                        label="Loading..."
                        class="mr-2"
                        variant="light"
                        v-if="showSpinner[1]"
                    ></b-spinner>PUBLISH
                </button>
            </div>
        </div>
    </section>
</template>
<script>
import { getCountryName, timezones } from "@/services/utils";
import { validationMixin } from "vuelidate";
import {
    required,
    minValue,
    maxValue,
    minLength,
    maxLength,
    requiredIf,
    url
} from "vuelidate/lib/validators";
import Timepicker from "@/components/Communities/Timepicker.vue";
import Description from "@/components/Communities/form/Description.vue";
import Warning from "@/components/Warning.vue";
import CmBack from "@/components/CmBack.vue";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
import axios from "axios";
import {
    startOfToday,
    isValid,
    parseISO,
    format,
    isAfter,
    endOfYesterday,
    isSameDay
} from "date-fns";
import { LANGUAGES_MAP } from "@/models/cm-languages.constant";

export default {
    name: "CreateEditMeetup",
    components: {
        Timepicker,
        Description,
        Warning,
        CmBack
    },
    data: () => ({
        firstStep: {
            name: "",
            venue: "",
            address: "",
            city: "",
            country: "",
            countryCode: "",
            zipCode: "",
            mapsId: "ChIJhdqtz4aI7UYRefD8s-aZ73I",
            streetNumber: "",
            lat: "",
            lng: "",
            seats: null,
            language: null,
            url: "",
            videoUrl: "",
            external_platform_url: ""
        },
        secondStep: {
            startDate: null,
            startTime: "",
            endDate: null,
            endTime: "",
            callForPaper: false,
            cfpOpenDate: null,
            cfpOpenTime: "",
            cfpCloseDate: null,
            cfpCloseTime: "",
            cfpDescription: "",
            cfpTimeSlots: []
        },
        dateErrorFlag: [],
        thirdStep: {
            banner: null,
            bannerPreview: "",
            description: "",
            needEmail: false,
            reservationsVisibility: false,
            autoWaiting: false
        },
        timeSlotsInput: "",
        callForPaperSlug: "",
        timezone: "",
        timezones: [],
        currentTz: "",
        editBanner: false,
        showInstructions: false,
        dirty: false,
        deleteConfirm: false,
        currentStatus: "",
        reservations: "",
        draft: false,
        showSpinner: [false, false, false],
        showMap: false,
        updateResultMessage: "",
        showUpdateResult: false,
        publishConfirm: false,
        loading: false,
        newId: "",
        loadingMeetup: false,
        colors: "",
        showColorPicker: false,
        online: false,
        venues: [],
        venueList: false
    }),

    watch: {
        // "firstStep.waitingList"(val) {
        //     if (val) this.thirdStep.reservationsVisibility = 0;
        // },
        secondStep: {
            deep: true,
            handler(val, oldVal) {
                this.dirty = true;
                this.dateErrorFlag = [];
                if (!this.isEdit) {
                    if (!this.dateSet && this.secondStep.callForPaper) {
                        this.secondStep.callForPaper = false;
                    }
                }
            }
        },
        "secondStep.startDate"(val) {
            if (isAfter(val, this.secondStep.endDate)) {
                this.secondStep.endDate = val;
            }
        },
        "secondStep.startTime"(val) {
            if (!this.secondStep.endTime) {
                this.secondStep.endTime = this.addMinutes(val, 120);
            }
        },
        thirdStep: {
            deep: true,
            handler(val, oldVal) {
                this.dirty = true;
            }
        },
        firstStep: {
            deep: true,
            handler(val, oldVal) {
                this.dirty = true;
            }
        },
        online() {
            this.dirty = true;
        }
    },
    mixins: [validationMixin],
    computed: {
        dateSet() {
            return this.secondStep.startDate &&
                this.secondStep.startTime &&
                this.secondStep.endDate &&
                this.secondStep.endTime
                ? true
                : false;
        },
        community() {
            return this.$store.getters.community;
        },
        meetup: {
            get() {
                return this.$store.getters.meetup;
            },
            set(val) {
                this.$store.commit("setMeetup", val);
            }
        },
        isEdit() {
            return this.meetup ? true : false;
        },
        languages() {
            return LANGUAGES_MAP;
        },
        canvasColor() {
            if (!this.colors) {
                return "transparent";
            } else {
                return this.colors.hex8;
            }
        }
    },
    validations: {
        firstStep: {
            name: {
                required,
                minLength: minLength(3)
            },
            seats: {
                required,
                minValue: minValue(1)
            },
            lat: {
                required: requiredIf(function() {
                    return !this.online;
                })
            },
            url: {
                required: requiredIf(function() {
                    return this.online;
                }),
                url
            },
            videoUrl: {
                url
            },
            external_platform_url: {
              url  
            },
            venue: {
                required: requiredIf(function() {
                    return !this.online;
                }),
                minLength: minLength(3)
            }
        },
        secondStep: {
            cfpTimeSlots: {
                required: requiredIf(function() {
                    return this.secondStep.callForPaper;
                })
            },
            cfpDescription: {
                required: requiredIf(function() {
                    return this.secondStep.callForPaper;
                })
            }
        },
        timezone: {
            required
        }
    },
    async mounted() {
        if (!this.community) {
            try {
                this.loadingMeetup = true;
                const community = await this.$communityApi.getCommunity(
                    this.$route.params.id
                );
                this.$store.commit("setCommunity", community);
            } catch (error) {
                console.error(error);
                this.$router.replace("/communities#management");
                return;
            }
        }
        this.autocomplete = new google.maps.places.Autocomplete(
            this.$refs["maps_autocomplete"],
            {
                types: ["address"],
                language: "en"
            }
        );
        this.autocomplete.addListener("place_changed", this.getPlace);
        if (this.$route.name === "meetup-new") {
            this.$store.commit("setMeetup", null);
        } else if (this.$route.name === "meetup-edit") {
            this.loadingMeetup = true;
            if (!this.meetup) {
                try {
                    const meetup = await this.$meetupApi.getMeetupById(
                        this.$route.params.meetupid
                    );
                    this.$store.commit("setMeetup", meetup.data);
                } catch (error) {
                    console.error(error);
                }
            }
            if (this.meetup.cfp_slug) {
                this.secondStep.callForPaper = true;
                try {
                    const cfp = await this.$cfpApi.getCfpBySlug(
                        this.meetup.cfp_slug
                    );
                    this.secondStep.callForPaper = true;

                    let tempStart, tempEnd;

                    tempStart = parseISO(cfp.start_datetime + "Z");
                    tempEnd = parseISO(cfp.end_datetime + "Z");

                    this.secondStep.cfpOpenDate = tempStart;
                    this.secondStep.cfpCloseDate = tempEnd;
                    this.secondStep.cfpOpenTime = format(tempStart, "HH:mm");
                    this.secondStep.cfpCloseTime = format(tempEnd, "HH:mm");
                    this.secondStep.cfpDescription = cfp.guidelines;
                    this.secondStep.cfpTimeSlots = [...cfp.lengths];
                } catch (error) {
                    console.error(error);
                }
            }
            this.loadingMeetup = false;
        }
        if (this.$route.query.cfp) {
            this.secondStep.callForPaper = true;
            const query = { ...this.$route.query };
            delete query.cfp;
            this.$router.replace({ query });

            setTimeout(() => {
                this.$scrollTo("#cfp", 300, { offset: -125 });
            }, 300);
        }

        if (this.meetup) {
            this.firstStep.name = this.meetup.name;
            if (this.meetup.timezone) {
                this.timezone = this.meetup.timezone;
            }
            if (this.meetup.location_google_id === "0") {
                this.online = true;
                this.firstStep.url = this.meetup.live_url;
                this.firstStep.videoUrl = this.meetup.video_url;
            } else {
                this.firstStep.lat = this.meetup.location_lat;
                this.firstStep.lng = this.meetup.location_lng;
                this.firstStep.mapsId = this.meetup.location_google_id;
                this.firstStep.venue = this.meetup.location_name;
                this.firstStep.address = this.meetup.location_address;
                this.firstStep.city = this.meetup.location_city;
                this.firstStep.country = this.meetup.location_country;
                this.firstStep.zipCode = this.meetup.location_zipcode;
                this.firstStep.streetNumber = this.meetup.location_street_number;
            }
            this.firstStep.language = this.meetup.language;

            if(this.meetup.external_platform_url != undefined) this.firstStep.external_platform_url = this.meetup.external_platform_url;

            let tempStart, tempEnd;

            tempStart = utcToZonedTime(this.meetup.start_datetime + "Z", this.timezone);
            tempEnd = utcToZonedTime(this.meetup.end_datetime + "Z", this.timezone);

            this.secondStep.startDate = tempStart;
            this.secondStep.endDate = tempEnd;
            this.secondStep.startTime = format(tempStart, "HH:mm");
            this.secondStep.endTime = format(tempEnd, "HH:mm");
            this.thirdStep.description = this.meetup.description || "";
            this.thirdStep.bannerPreview = this.meetup.banner_url;
            this.thirdStep.reservationsVisibility =
                this.meetup.reservations_visibility !== undefined
                    ? this.meetup.reservations_visibility
                        ? true
                        : false
                    : true;
            this.thirdStep.autoWaiting =
                this.meetup.auto_include_waiting !== undefined
                    ? this.meetup.auto_include_waiting
                        ? true
                        : false
                    : false;
            this.firstStep.seats = this.meetup.seats_total;
            this.currentStatus = this.meetup.status;
            this.reservations = this.meetup.reservations;

            this.callForPaperSlug = this.meetup.cfp_slug || "";

            setTimeout(() => (this.dirty = false), 1200);
        } else {
            this.secondStep.startDate = startOfToday();
            this.secondStep.endDate = this.secondStep.startDate;
        }

        try {
            this.venues = await this.$meetupApi.getVenues(
                this.$route.params.id
            );
        } catch (error) {
            console.error(error);
        }
        this.loadingMeetup = false;
    },
    methods: {
        addMinutes(time, minsToAdd) {
            function D(J) {
                return (J < 10 ? "0" : "") + J;
            }
            var piece = time.split(":");
            var mins = piece[0] * 60 + +piece[1] + +minsToAdd;
            return D(((mins % (24 * 60)) / 60) | 0) + ":" + D(mins % 60);
        },
        selectVenue(venue) {
            this.firstStep.lat = venue.location_lat;
            this.firstStep.lng = venue.location_lng;
            this.firstStep.mapsId = venue.location_google_id;
            this.firstStep.address = venue.location_address;
            this.firstStep.venue = venue.location_name;
            this.firstStep.city = venue.location_city;
            this.firstStep.zipCode = venue.location_zipcode;
            this.firstStep.streetNumber = venue.location_street_number;
            this.firstStep.country = venue.location_country;
            this.firstStep.seats = venue.seats_total;
        },
        alert(msg) {
            alert(msg);
        },
        resetLocation() {
            this.firstStep.lat = "";
            this.firstStep.lng = "";
            this.firstStep.mapsId = "ChIJhdqtz4aI7UYRefD8s-aZ73I";
            this.firstStep.address = "";
            this.firstStep.city = "";
            this.firstStep.zipCode = "";
            this.firstStep.streetNumber = "";
            this.firstStep.country = "";
            this.firstStep.countryCode = "";
        },
        checkDate(date, step, cfp) {
            if (!cfp) {
                if (step === "first") {
                    if (isAfter(date, endOfYesterday())) {
                        return false;
                    }
                }
                if (step === "second") {
                    if (isSameDay(date, this.secondStep.startDate)) {
                        return false;
                    } else if (isAfter(date, this.secondStep.startDate)) {
                        return false;
                    }
                }
                return true;
            } else {
                if (!this.secondStep.endDate) {
                    return true;
                }
                if (step === "first") {
                    if (
                        isAfter(this.secondStep.startDate, date) &&
                        isAfter(date, endOfYesterday())
                    ) {
                        return false;
                    }
                }
                if (step === "second") {
                    if (isSameDay(date, this.secondStep.cfpOpenDate)) {
                        return false;
                    } else if (
                        isAfter(date, this.secondStep.cfpOpenDate) &&
                        isAfter(this.secondStep.startDate, date)
                    ) {
                        return false;
                    }
                }
                return true;
            }
        },
        getValidationClass(fieldName, step) {
            if (step) {
                const field = this.$v[step][fieldName];
                               if (field) {
                    return {
                        "md-invalid": field.$invalid && field.$dirty
                    };
                }
                return;
            }
            const field = this.$v.firstStep[fieldName];
            if (field) {
                return {
                    "md-invalid": field.$invalid && field.$dirty
                };
            }
        },
        checkDateErrors() {
            this.dateErrorFlag = [];
            const hourCheck = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
            if (
                hourCheck.test(this.secondStep.startTime) &&
                hourCheck.test(this.secondStep.endTime) &&
                isValid(this.secondStep.startDate) &&
                isValid(this.secondStep.endDate)
            ) {
                if (
                    isAfter(this.secondStep.startDate, this.secondStep.endDate)
                ) {
                    this.dateErrorFlag.push("date_mismatch");
                    return false;
                } else if (
                    isSameDay(
                        this.secondStep.startDate,
                        this.secondStep.endDate
                    )
                ) {
                    if (
                        isAfter(
                            parseISO(
                                "2011-01-01 " +
                                    this.secondStep.startTime +
                                    ":00"
                            ),
                            parseISO(
                                "2011-01-01 " + this.secondStep.endTime + ":00"
                            )
                        )
                    ) {
                        this.dateErrorFlag.push("time_mismatch");
                        return false;
                    }
                    return true;
                }
            } else {
                this.dateErrorFlag.push("date_time_not_valid");
                return false;
            }
            if (this.secondStep.callForPaper) {
                if (
                    hourCheck.test(this.secondStep.cfpOpenTime) &&
                    hourCheck.test(this.secondStep.cfpCloseTime) &&
                    isValid(this.secondStep.cfpOpenDate) &&
                    isValid(this.secondStep.cfpCloseDate)
                ) {
                    if (
                        isAfter(
                            this.secondStep.cfpOpenDate,
                            this.secondStep.cfpCloseDate
                        )
                    ) {
                        this.dateErrorFlag.push("cfp_date_mismatch");
                        return false;
                    } else if (
                        isSameDay(
                            this.secondStep.cfpOpenDate,
                            this.secondStep.cfpCloseDate
                        )
                    ) {
                        if (
                            isAfter(
                                parseISO(
                                    "2011-01-01 " +
                                        this.secondStep.cfpOpenTime +
                                        ":00"
                                ),
                                parseISO(
                                    "2011-01-01 " +
                                        this.secondStep.cfpCloseTime +
                                        ":00"
                                )
                            )
                        ) {
                            this.dateErrorFlag.push("cfp_time_mismatch");
                            return false;
                        }
                        return true;
                    }
                } else {
                    this.dateErrorFlag.push("cfp_date_time_not_valid");
                    return false;
                }
            }
            return true;
        },
        async deleteMeetup() {
            if (this.loading) return;
            this.loading = true;
            let close = false;
            try {
                this.showSpinner[2] = true;
                const res = await this.$meetupApi.deleteMeetup(this.meetup.id);

                this.updateResultMessage = "Meetup successfully deleted.";
                close = true;
                return res;
            } catch (error) {
                this.updateResultMessage = error.message;
            } finally {
                this.showSpinner[2] = false;
                this.showUpdateResult = true;
                this.loading = false;
            }
        },
        errorsCheck() {
            this.$v.$touch();
            const dateErrors = !this.checkDateErrors();
            if (!this.$v.$invalid && !dateErrors) {
                return true;
            } else {
                this.updateResultMessage =
                    "There are some errors. Check the form.";
                this.showUpdateResult = true;
                return false;
            }
        },
        getUTCTimestamp(date) {
            let temp = zonedTimeToUtc(date, this.timezone);
            temp = parseISO(temp.toISOString().slice(0, -1));
            return format(temp, "yyyy-MM-dd HH:mm:ss", {
                timezone: this.timezone
            });
        },
        async setDone(spinner) {
            if (this.loading) return;
            this.loading = true;

            const fMeetup = {
                name: this.firstStep.name,
                description: this.thirdStep.description,
                start_datetime: this.getUTCTimestamp(
                    `${format(this.secondStep.startDate, "yyyy-MM-dd")} ${
                        this.secondStep.startTime
                    }:00`
                ),
                end_datetime: this.getUTCTimestamp(
                    `${format(this.secondStep.endDate, "yyyy-MM-dd")} ${
                        this.secondStep.endTime
                    }:00`
                ),
                live_url: this.online ? this.firstStep.url : undefined,
                video_url: this.online ? this.firstStep.videoUrl : undefined,
                location_name: this.online ? "ONLINE" : this.firstStep.venue,
                location_google_id: this.online ? "0" : this.firstStep.mapsId,
                location_lat: this.online ? "0" : this.firstStep.lat,
                location_lng: this.online ? "0" : this.firstStep.lng,
                location_address: this.online
                    ? "ONLINE"
                    : this.firstStep.address,
                location_zipcode: this.online ? "0" : this.firstStep.zipCode,
                location_city: this.online ? "ONLINE" : this.firstStep.city,
                location_country: this.online ? "0" : this.firstStep.country,
                location_street_number: this.online
                    ? "0"
                    : this.firstStep.streetNumber,
                seats_total: this.firstStep.seats,
                language: this.firstStep.language,
                organizer_id: this.$route.params.id,
                organizer_name: this.community.name,
                organizer_slug: this.community.slug,
                organizer_logo_url: this.community.logo,
                timezone: this.timezone,
                topics: this.community.topics
                    .reduce((str, el) => str + "," + el.name, "")
                    .slice(1),
                status:
                    spinner === 1
                        ? "published"
                        : this.draft
                        ? "draft"
                        : this.currentStatus,
                needEmail: this.thirdStep.needEmail ? 1 : 0,
                reservations_visibility: this.thirdStep.reservationsVisibility
                    ? 1
                    : 0,
                cfp:
                    this.callForPaperSlug || this.secondStep.callForPaper
                        ? {
                              start_datetime: this.getUTCTimestamp(
                                  `${format(
                                      this.secondStep.cfpOpenDate,
                                      "yyyy-MM-dd"
                                  )} ${this.secondStep.cfpOpenTime}:00`
                              ),
                              end_datetime: this.getUTCTimestamp(
                                  `${format(
                                      this.secondStep.cfpCloseDate,
                                      "yyyy-MM-dd"
                                  )} ${this.secondStep.cfpCloseTime}:00`
                              ),
                              guidelines: this.secondStep.cfpDescription,
                              lengths: this.secondStep.cfpTimeSlots.map(el =>
                                  parseInt(el, 10)
                              )
                          }
                        : undefined,
                auto_include_waiting: this.thirdStep.autoWaiting ? 1 : 0
            };

            if (this.firstStep.external_platform_url) fMeetup.external_platform_url = this.firstStep.external_platform_url;

            this.thirdStep.banner =
                this.showInstructions &&
                this.$refs.croppa.generateDataUrl("image/png", 0.8);
            this.isEdit && (fMeetup["id"] = this.meetup.id || this.newId);
            this.showSpinner[spinner] = true;
            const mid = this.isEdit
                ? await this.updateMeetup(fMeetup)
                : await this.uploadMeetup(fMeetup);
            this.loading = false;
        },
        async uploadMeetup(meetup) {
            try {
                const mid = await this.$meetupApi.addMeetup(
                    meetup,
                    this.thirdStep.banner || undefined
                );
                this.updateResultMessage = "Create complete with success!";
                this.currentStatus = meetup.status;
                this.meetup = meetup;
                this.draft = false;
                this.dirty = false;
                this.newId = mid;
                return mid;
            } catch (error) {
                this.updateResultMessage = error.message;
            } finally {
                this.showSpinner = [false, false, false];
                this.showUpdateResult = true;
            }
        },
        async updateMeetup(meetup) {
            try {
                const res = await this.$meetupApi.updateMeetup(
                    meetup,
                    this.thirdStep.banner || undefined
                );
                this.updateResultMessage = "Update successful!";
                this.currentStatus = meetup.status;
                this.meetup = meetup;
                this.draft = false;
                this.dirty = false;
                return res;
            } catch (error) {
                this.updateResultMessage = error.message;
            } finally {
                this.showSpinner = [false, false, false];
                this.showUpdateResult = true;
            }
        },
        getPlace() {
            this.resetLocation();
            const place = this.autocomplete.getPlace();
            this.firstStep.lat = place.geometry.location.lat().toString();
            this.firstStep.lng = place.geometry.location.lng().toString();
            this.firstStep.address = place.formatted_address;

            const ac = place.address_components;
            ac.forEach(el => {
                if (el.types.includes("street_number")) {
                    this.firstStep.streetNumber = el.long_name;
                }
                if (
                    el.types.includes("locality") ||
                    el.types.includes("administrative_area_level_3")
                ) {
                    this.firstStep.city = el.long_name;
                }
                if (el.types.includes("postal_code")) {
                    this.firstStep.zipCode = el.short_name || el.long_name;
                }
                if (el.types.includes("country")) {
                    this.firstStep.country = el.long_name;
                    this.firstStep.countryCode = el.short_name;
                }
            });
            this.firstStep.mapsId = place.place_id;
        },
        deleteLang() {
            this.firstStep.language = null;
        }
    },
    async beforeMount() {
        try {
            const temp = await axios.get(
                "https://worldtimeapi.org/api/timezone"
            );
            this.timezones = temp.data;
        } catch (error) {
            this.timezones = [...timezones];
        }
        try {
            const currentTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (currentTz) {
                this.timezone = currentTz;
            }
        } catch (error) {
            console.error(error);
        }
    }
};
</script>
<style lang="scss">
.croppa-container svg {
    top: -9px !important;
    right: -5px !important;
}
</style>
<style lang="scss" scoped>
.md-menu-content,
.md-datepicker-dialog {
    z-index: 1041 !important;
}
.md-icon:after {
    background-color: transparent !important;
}
.md-layout-item {
    justify-content: flex-end;
    display: flex;
    flex-direction: column;
}
.alert-modal {
    z-index: 1050 !important;
}
// .v-note-wrapper {
//     z-index: 5 !important;
//     min-width: 240px !important;
//     &.fullscreen {
//         margin-top: 115px !important;
//         z-index: 1050 !important;
//     }
// }

.venues-list-item .venues-list-item-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    strong,
    small {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    strong {
        font-weight: 600;
    }
}
.second-step {
    .md-field > .md-icon:after {
        height: 0 !important;
    }
}
.op-image.popup-dropdown .dropdown-item:last-of-type {
    display: none;
}
.third-step {
    .croppa-container canvas {
        width: auto !important;
        height: auto !important;
    }
}
</style>
<style lang="scss" scoped>
@import "@/assets/scss/_common.scss";
#wrapper-create-meetup {
    .wrap-title-breadscrumbs {
        line-height: 1.2;
    }
}

.actions-container {
    &.sticky {
        position: sticky;
        bottom: 0;
        z-index: 15;
    }
    width: 100%;
    padding: 15px;
    border-top: 1px solid #e6e6e6;
    background: white;
    & > div {
        max-width: 915px;
        margin: auto;
        justify-content: flex-end;
    }
}
.create-edit-meetups {
    max-width: 915px;

    .form-block {
        width: 100%;
        padding-bottom: 20px;
        // input {
        //     margin-top: 10px;
        // }
        @media all and (min-width: $size-tablet-landscape) {
            display: flex;
            max-width: 100%;
            & > h3 {
                padding-right: 15px;
            }
        }
        h3 {
            text-align: left;
            font-size: 16px;
            padding-bottom: 10px;
            margin-top: 10px;
            border-bottom: 0px solid #e4e4ea;
            @media all and (min-width: $size-tablet-landscape) {
                width: 20%;
                border: none;
                border-right: 2px solid #e4e4ea;
                margin: 0;
                padding: 10px 0;
            }
        }
    }

    .fields-container {
        display: flex;
        flex-direction: column;
        padding-top: 5px;
        @media all and (min-width: $size-tablet-landscape) {
            padding-left: 25px;
            width: 80%;
        }
        h3 {
            margin-left: 20px;
            border: none;
            small {
                display: block;
            }
        }
        .delete-button {
            padding-top: 16px;
            display: flex;
            min-height: 48px;
            position: relative;
            margin: 4px 0 0;
        }

        .banner {
            text-align: center;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width: 800px;
            margin: 15px 0;

            img {
                width: 100%;
                border: 2px dashed #979797;
                border-radius: 5px;
                object-fit: cover;
            }
            i {
                position: absolute;
                cursor: pointer;
                top: 15px;
                right: 15px;
                font-size: 24px;
                padding: 3px;
                background: white;
                color: $palette-orange;
                border-radius: 50%;
            }
            label {
                z-index: 1;
            }
            .instructions {
                position: absolute;
                padding: 0 10px;
                background: #97979797;
                font-weight: bolder;
                color: white;
                z-index: 10;
                bottom: 0;
                font-size: 12px;
                border-radius: 5px;
                @media all and (min-width: $size-tablet-portrait) {
                    font-size: 18px;
                }
            }
        }
        a {
            margin-top: 8px !important;
        }

        .wrap-color-picker {
            position: relative;
            @media (min-width: 1430px) {
                position: absolute;
                right: -234px;
                z-index: 1;
                top: 15px;
            }
        }

        .wrap-close-button {
            cursor: pointer;
            width: 225px;
            text-align: right;
        }

        .wrap-info-croppa {
            position: absolute;
            z-index: 0;
            h5 {
                font-size: 0.9rem;
                @media all and (min-width: $size-tablet-landscape) {
                    font-size: 1.25rem;
                }
            }

            p {
                font-size: 0.7rem;
                margin-bottom: 0;
                @media all and (min-width: $size-tablet-landscape) {
                    font-size: 1rem;
                }
            }
        }

        .wrap-checkboard {
            position: absolute;
            width: 100%;
            height: 100%;
            z-index: 1;
            .img {
                object-fit: cover;
                border: none;
                background-repeat: no-repeat;
                width: 100%;
                height: 100%;
            }
        }
    }

    .md-button {
        font-weight: 600 !important;
    }

    input::placeholder {
        color: #575757 !important;
    }
    .first-step {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .seats {
            input {
                width: 100%;
            }
        }

        .md-field {
            margin-bottom: 0;
            &.md-invalid {
                margin-bottom: 18px;
            }
        }

        .inputs {
            width: 100%;
            @media all and (min-width: $size-large-portrait) {
                width: 50%;
                padding-right: 25px;
            }
            input {
                width: 100%;
            }
        }
        iframe.show-map {
            display: block !important;
            width: 100%;
            height: 199px;
        }
        p.show-map {
            color: $palette-orange;
            cursor: pointer;
            width: 100%;
            margin-top: 15px;
            @media all and (min-width: $size-large-portrait) {
                display: none;
            }
        }
        iframe {
            display: none;
            height: 224px;
            @media all and (min-width: $size-large-portrait) {
                display: block;
                width: 100%;
                padding-top: 25px;
            }
        }
        // span {
        //     display: flex;
        //     :first-child {
        //         margin-right: 10px;
        //     }
        // }

        // .seats-box {
        //     align-items: flex-end;
        //     justify-content: space-between;
        //     :first-child {
        //         margin-right: 0;
        //     }
        //     .md-field {
        //         max-width: 140px;
        //     }
        //     .md-checkbox {
        //         width: auto;
        //     }
        //     label {
        //         padding: 0;
        //     }
        // }
    }
    .second-step {
        .time-container {
            min-height: 76px;
        }
        .date,
        .time {
            width: 100%;
            @media all and (min-width: $size-tablet-portrait) {
                width: 50%;
            }
        }

        .md-field {
            margin-bottom: 0;
        }

        .md-error {
            color: red;
            font-size: 12px;
            transition: all 0.5s ease;
        }

        .cfp-check {
            span {
                display: flex;
                align-items: center;
                width: 202px;
            }
            padding: 3px;
            margin-top: 15px;
            label {
                color: $palette-blue !important;
                margin: 0;
                margin-left: 10px;
            }
        }
        .cfp-box {
            padding: 20px;
            border-radius: 15px;
            border: 1px solid #e4e4ea;
            background: #ffffff;
        }
        input {
            margin: 0;
        }
        .add-label {
            cursor: pointer;
            color: $palette-orange;
            position: absolute;
            right: 20px;
            top: 21px;
            transition: all 0.5s ease;
            @media all and (max-width: $size-tablet-portrait) {
                right: 3px;
            }
        }
    }
    .third-step {
        .notify-box {
            background: #fff;
            border-radius: 5px;
            padding: 12px;
            margin: 5px 0;
            display: flex;
            align-items: center;
            border: 1px solid #e4e4ea;

            label {
                margin-bottom: 0 !important;
                margin-left: 10px;
                color: $palette-blue !important;
            }
        }
        .op-image.popup-dropdown .dropdown-item:last-of-type {
            display: none;
        }

        .add-meetup-banner {
            width: 100%;
            position: relative;
            display: flex;
        }
    }

    .googlemaps #placeholder {
        font-weight: 500 !important;
    }

    .md-field .md-input::-webkit-input-placeholder,
    .md-field .md-textarea::-webkit-input-placeholder {
        font-weight: 500 !important;
    }
}
</style>